import { render, staticRenderFns } from "./DetailsStep.vue?vue&type=template&id=3fa5d81a&scoped=true"
import script from "./DetailsStep.vue?vue&type=script&lang=js"
export * from "./DetailsStep.vue?vue&type=script&lang=js"
import style0 from "./DetailsStep.vue?vue&type=style&index=0&id=3fa5d81a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa5d81a",
  null
  
)

export default component.exports